/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Get_ReadyInputs */

const en_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Ready!`)
};

const fr_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparez-vous !`)
};

const de_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macht euch bereit!`)
};

const it_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparatevi!`)
};

const ru_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приготовьтесь!`)
};

const es_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Prepararse!`)
};

const zh_cn2_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备！`)
};

const ja_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備しましょう！`)
};

const hi_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तैयार हो जाओ!`)
};

const pt_pt2_audio_recorder_get_ready = /** @type {(inputs: Audio_Recorder_Get_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare-se!`)
};

/**
* | output |
* | --- |
* | "Get Ready!" |
*
* @param {Audio_Recorder_Get_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_get_ready = /** @type {((inputs?: Audio_Recorder_Get_ReadyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Get_ReadyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_get_ready(inputs)
	if (locale === "de") return de_audio_recorder_get_ready(inputs)
	if (locale === "it") return it_audio_recorder_get_ready(inputs)
	if (locale === "ru") return ru_audio_recorder_get_ready(inputs)
	if (locale === "es") return es_audio_recorder_get_ready(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_get_ready(inputs)
	if (locale === "ja") return ja_audio_recorder_get_ready(inputs)
	if (locale === "hi") return hi_audio_recorder_get_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_get_ready(inputs)
	return en_audio_recorder_get_ready(inputs)
});